/** @module csi/widget/_svg/ModeShape */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dijit/form/ComboButton",
	"csi/locale",
	"../SvgShapePalette",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(declare,lang,domClass,ComboButton,locale,SvgShapePalette,_Plugin,PluginFactory, util) {

	return PluginFactory.declare([ComboButton, _Plugin], {
		"class": "csi-button-toggle",
		iconClass: "csiActionIcon",
		pluginName: "shapeSelect",

		/** @property {string} _lastIcon - last selected shape icon class */
		_lastIcon: null,


		/**
		 * Create shape palette and initialize icon
		 */
		postCreate: function() {
			this.dropDown = new SvgShapePalette({
				onChange: lang.hitch(this, this.onChangeShape)
			});

			this._updateShape();
			this.inherited(arguments);
		},

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			var enabled = this.inherited(arguments);
			this._setToggled(this.editor.isDrawMode(this.pluginName) && (!shapes || !shapes.length) && !this.editor.canvasData.isPlaceholder);
			return enabled;
		},

		/**
		 * Update icon and set draw mode
		 * @param  {Object} shape
		 */
		onChangeShape: function(shape) {
			this._updateShape();
			this.onClick();
		},

		/**
		 * Set drag mode based on selected shape
		 */
		onClick: function() {
			var shape = this.dropDown.get("value");
			this.editor.setDrawMode(shape.shapeType);
			this._setToggled(true);
		},

		/**
		 * Set toggle status; if use "checked" attribute, then drop-down button also gets styling which we don't want
		 */
		_setToggled: function(b) {
			domClass.toggle(this.domNode, "dijitChecked", !!b);
		},

		/**
		 *  Need to translate "none" to background color of toolbar for icon color
		 */
		_updateShape: function() {
			var shape = this.dropDown.get("value");
			this.set("title", locale.resource(shape.title));
			this.set("iconClass", "csiActionIcon " + shape.icon);
		}
	});
});
